import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 19v.01","key":"svg-0"}],["path",{"d":"M12 15v-10","key":"svg-1"}]]

const IconExclamationMark = createReactComponent('outline', 'exclamation-mark', 'ExclamationMark', __iconNode);

export default IconExclamationMark;